import React from "react";
import { Spin, Typography } from "antd";

const Loader = (props) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spin />
      <Typography>Уншиж байна, түр хүлээнэ үү.</Typography>
    </div>
  );
};

export default Loader;
